import React from 'react';

/** variant: form (accept UI), signup / signin (auth alerts with CTA). */
export default function InvitationDescription({
  invitationData,
  variant = 'form',
}) {
  const companyName =
    invitationData?.invitedBy?.companyDetails?.companyName ?? '';
  const teamName = invitationData?.invitedTo?.teamName ?? '';
  const role = invitationData?.invitedAs ?? '';
  const isAdmin = role === 'Admin';
  const article = role === 'Admin' ? 'an' : 'a';
  const bold = variant === 'form' ? 'text-dark' : 'font-weight-bold text-dark';

  const body = isAdmin ? (
    <>
      You&apos;ve been invited by <b className={bold}>{companyName}</b> to join
      the company as {article} <b className={bold}>{role}</b>.
    </>
  ) : (
    <>
      You&apos;ve been invited by <b className={bold}>{companyName}</b> to join
      the <b className={bold}>{teamName}</b> department as {article}{' '}
      <b className={bold}>{role}</b>
    </>
  );

  const ctaLine =
    variant === 'signup'
      ? 'Please sign up to accept the invitation.'
      : variant === 'signin'
        ? 'Please sign in to accept the invitation.'
        : '';

  const className =
    variant === 'form' ? 'font-weight-bold mt-1' : 'mb-0 text-sm';

  return (
    <p className={className}>
      {body}
      {ctaLine ? (
        <>
          <br />
          {ctaLine}
        </>
      ) : null}
    </p>
  );
}
